import { render, staticRenderFns } from "./lian_zhang.vue?vue&type=template&id=480fd8af&scoped=true&"
import script from "./lian_zhang.vue?vue&type=script&lang=js&"
export * from "./lian_zhang.vue?vue&type=script&lang=js&"
import style0 from "./lian_zhang.vue?vue&type=style&index=0&id=480fd8af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fd8af",
  null
  
)

export default component.exports